// тут можно переписать и использовать метод navigator.clipboard.writeText(text) - все в одну строку
export function copyToClipboard (text) {
  const textarea = document.createElement('textarea')
  textarea.setAttribute('style', 'position:absolute; left:-1000px')
  textarea.innerHTML = text
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('copy')
  document.body.removeChild(textarea)
}

/**
 * Генерирует уникальный идентификатор на основе буквенно-числового значения,
 * используя верхний и нижний регистр.
 *
 * @param {number} length - Длинна идентификатора.
 * @returns {string} Уникальный идентификатор вида "nOPo5" заданной длины.
 */
export function generateSecureID (length = 5) {
  const chars = 'AaBbCcDdEeFfGgHhIiJjKkLlMmNnOPoQqRrSsTtUuVvWwXxYyZz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

/**
 * Генерирует уникальное имя на основе переданного значения,
 * проверяя его наличие в списке существующих имён и добавляя
 * числовую суффиксацию в круглых скобках при необходимости.
 *
 * @param {string[]} existingNames - Список уже существующих имён.
 * @param {string} baseName - Базовое имя.
 * @returns {string} Уникальное имя вида "baseName(N)", где N — наименьшее целое ≥ 1,
 *                   не вызывающее коллизии. Если коллизий нет — возвращает baseName.
 */
export const makeUniqName = (existingNames = [], baseName = '') => {
  const candidates = existingNames.filter(name => name.startsWith(baseName))

  if (!candidates.includes(baseName)) {
    return baseName
  }

  let maxNumber = 0
  for (const name of candidates) {
    const match = name.match(new RegExp(`^${escapeRegExp(baseName)}\\((\\d+)\\)$`))
    if (match) {
      const num = parseInt(match[1], 10)
      if (num > maxNumber) maxNumber = num
    }
  }

  return `${baseName}(${maxNumber + 1})`
}

const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
